import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { MyContext } from "../../../MyContext/MyProvider";
import { useContext, useEffect } from "react";
import './style.css'

const ReactDocViewer = () => {
  const { docs } = useContext(MyContext);

  const docViewerDocs = docs.map((file) => ({
    uri: URL.createObjectURL(file),
  }));

  useEffect(() => {
    return () => {
      docViewerDocs.forEach((doc) => URL.revokeObjectURL(doc.uri));
    };
  }, [docs]);

  return (
    <>
      {docs.length ? (
        <div className="viewer">
          <DocViewer
          style={{ width: 700, height: 800 }}
            documents={docViewerDocs}
            pluginRenderers={DocViewerRenderers}
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default ReactDocViewer;
